@import '~style-sheet-helpers/core.less';

.body-inputs {
  display: grid;
  grid-template-columns: 100px 200px;
}

.loading-icon {
  height: 32px;
  width: 32px;
  margin: auto;
}

.adjust-inventory {
  min-width: 330px;
}
